import { render, staticRenderFns } from "./detailsBash.vue?vue&type=template&id=f61d51ce&scoped=true&"
import script from "./detailsBash.vue?vue&type=script&lang=js&"
export * from "./detailsBash.vue?vue&type=script&lang=js&"
import style0 from "./detailsBash.vue?vue&type=style&index=0&id=f61d51ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61d51ce",
  null
  
)

export default component.exports